<template>
  <div v-loading="showFlag">
    <t-card>
      <t-form
        ref="userRolesFormData"
        domain="userManage"
        label-position="right"
        label-width="100px"
        class="userRolesForm"
      >
        <t-row type="flex" justify="center">
          <t-col :span="24" class="col_common_center">
            <template>
              <t-transfer
                v-model="RolesSelectList"
                :props="{
                  key: 'RoleId',
                  label: 'RoleName',
                }"
                :data="this.RolesList"
                :titles="[
                  $t('resource.userManager.Roles'),
                  $t('resource.userManager.UserRoles'),
                ]"
                filterable
              >
              </t-transfer>
            </template>
          </t-col>
        </t-row>
        <t-row>
          <t-col :span="24" style="padding-top: 10px">
            <t-form-item class="float-right">
              <!-- 変更 -->
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                @click="Confirm"
              >
                <i class="el-icon-check"></i
                >{{ $t("resource.button.change") }}</t-button
              >
            </t-form-item>
          </t-col>
        </t-row>
      </t-form>
    </t-card>
  </div>
</template>

<script>
import { t } from "@/locales";
import { SearchUserRole, UpdateUserRole } from "@/services/userRoleInfo";
import { cmpDetailData } from "@/utils/comFunction";
import { Message, Modal } from "@tellus/component";

export default {
  props: {
    userId: {
      type: String,
    },
  },

  data() {
    return {
      //得意先リスト
      RolesList: [],
      //担当得意先情報リスト
      userRolesList: [],
      //選択した担当得意先情報リスト
      userRolesOutList: [],
      //担当(選択)得意先データの作成
      RolesSelectList: [],
      //待ち表示フラグ
      showFlag: false,

      // 読み込み回数
      numLoads: 1,

      // 比較用基本情報
      cmpBasicResult: {},
    };
  },

  computed: {},

  mounted() {
    this.Init();
  },

  computed: {},

  methods: {
    // 初期化
    Init() {
      //console.log("this.userId---" + JSON.stringify(this.userId));

      this.showFlag = true;
      this.SearchUserRole();
    },

    // 検索
    SearchUserRole() {
      SearchUserRole(this.userId)
        .then((res) => {
          //得意先リスト
          this.RolesList = res.SystemRoleList;
          //担当得意先情報リスト
          this.userRolesList = res.UserRoleList;
          this.showFlag = false;

          //担当(選択)得意先データの作成
          for (let i = 0; i < this.userRolesList.length; i++) {
            this.RolesSelectList.push(this.userRolesList[i].RoleId);
          }

          // 読み込み回数 = 1
          if (!this.isAddFlg && this.numLoads == 1) {
            // 比較用基本情報
            this.cmpBasicResult = JSON.parse(
              JSON.stringify(this.RolesSelectList.sort())
            );

            // 読み込み回数 + 1
            this.numLoads = this.numLoads + 1;
          }
        })
        .catch((err) => {
          this.showFlag = false;
          Message.showError(t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE"));
        });
    },

    // 編集
    Confirm() {
      this.showFlag = true;
      //担当得意先のクリア
      this.userRolesOutList.length = 0;

      //選択した得意先の繰り返し
      for (let i = 0; i < this.RolesSelectList.length; i++) {
        //選択した担当得意先
        this.userRolesOutList.push({
          //ユーザーID
          UserId: this.userId,
          //権限ID
          RoleId: this.RolesSelectList[i],
        });
      }

      if (this.userRolesOutList.length == 0) {
        Modal.showWarning(
          "",
          t("message.COMMON_MESSAGE.PLEASE_SELECT_ROLE_DATA"),
          {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          }
        );

        this.showFlag = false;
        return;
      }

      UpdateUserRole(this.userRolesOutList)
        .then((res) => {
          // console.log("showSuccess");
          this.showFlag = false;
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
          this.numLoads = 1;
          this.SearchUserRole();
        })
        .catch((err) => {
          this.showFlag = false;
          // console.log("showError");
          Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
        });
    },

    // ダイアログを閉じる
    onCancel() {
      if (
        !this.isAddFlg &&
        !cmpDetailData(this.cmpBasicResult, this.RolesSelectList.sort())
      ) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },
  },
};
</script>
<style>
.el-transfer-panel {
  width: 230px;
}

.el-transfer-panel__body {
  height: 380px;
}

.el-transfer-panel__list {
  height: 350px !important;
}
</style>
